import { getApiBaseURL } from '@/services/api';

/**
 * URL absoluta para imagens/ficheiros servidos pela API (ex.: /uploads/participantes/...).
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const t = url.trim();
  if (!t) return '';
  if (t.startsWith('http://') || t.startsWith('https://')) return t;
  const base = getApiBaseURL().replace(/\/$/, '');
  const path = t.startsWith('/') ? t : `/${t}`;
  return `${base}${path}`;
}
